import Bookrunner from "./meta/Bookrunner";
import TransactionCompanyWrapper from "./TransactionCompanyWrapper";
class TrancheMeta {
    bookrunners;
    lei;
    parties;
    pricingDate;
    ticker;
    status;
    tap;
    constructor(response) {
        this.bookrunners = response?.bookrunners ? response.bookrunners.map(b => new Bookrunner(b)) : undefined;
        this.lei = response?.lei;
        this.parties = response?.parties ? response.parties.map(p => new TransactionCompanyWrapper(p)) : undefined;
        this.pricingDate = response?.pricingDate !== undefined ? new Date(response.pricingDate) : undefined;
        this.ticker = response?.ticker;
        this.status = response?.status;
        this.tap = response?.tap;
    }
    toResponse() {
        return {
            bookrunners: this.bookrunners,
            lei: this.lei,
            pricingDate: this.pricingDate ? this.pricingDate.toISOString().substring(0, 10) : undefined,
            ticker: this.ticker,
            status: this.status,
            tap: this.tap
        };
    }
}
export default TrancheMeta;
